import { sumColumn } from "./utils";
import { i18n } from "../translate/i18n";

const { t } = i18n;

export const forecastColumns = () => {
  return [
    {
      label: t("partPercent"),
      name: "participationInAidron",
      fullLabel: t("percentParticipation"),
      type: "%",
      calculate: values => calculateParticipation(values),
    },
    {
      label: t("currentPlan"),
      name: "clientPrediction",
      type: "demand",
      calculate: values => sumColumn(values.selectedPredictions, values.name),
    },
    {
      label: t("ai"),
      name: "aidronPrediction",
      fullLabel: t("aiForecast"),
      type: "prediction",
      calculate: values => sumColumn(values.selectedPredictions, values.name),
    },
    {
      label: t("differenceAidronAndClient"),
      name: "differenceAidronAndClient",
      indexOne: "aidronPrediction",
      indexTwo: "clientPrediction",
      type: "dif",
      calculate: values => calculateDiff(values),
      colorReferenceFrom: "percentAidronVsClient",
    },
    {
      label: t("percentAidronVsClient"),
      name: "percentAidronVsClient",
      indexOne: "aidronPrediction",
      indexTwo: "clientPrediction",
      type: "dif%",
      calculate: values => calculateDiffPercent(values),
    },
  ];
};

export const historicColumns = ({ unit }) => {
  return [
    {
      label: t("realized"),
      name: "realized",
      fullLabel: t("realizedSales"),
      type: "demand",
    },
    {
      label: t("partPercent"),
      name: "participationInRealized",
      fullLabel: t("percentParticipationInRealized"),
      type: "%",
    },
  ];
};

function calculateParticipation(values) {
  const allPredictions = sumColumn(values.allPredictions, values.name);
  const selectedPredictions = sumColumn(values.selectedPredictions, values.name);
  return (selectedPredictions / allPredictions) * 100;
}

function calculateDiff(values) {
  const sumIndexOne = sumColumn(values.selectedPredictions, values.indexOne);
  const sumIndexTwo = sumColumn(values.selectedPredictions, values.indexTwo);
  return sumIndexOne - sumIndexTwo;
}

function calculateDiffPercent(values) {
  const sumIndexOne = sumColumn(values.selectedPredictions, values.indexOne);
  const sumIndexTwo = sumColumn(values.selectedPredictions, values.indexTwo);

  if (sumIndexOne && sumIndexTwo) {
    return ((sumIndexOne - sumIndexTwo) / sumIndexTwo) * 100;
  } else {
    return null;
  }
}